import { SortOrder } from '@store/slices/generic.slice'

export const formatDate = (date: Date): string => {
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = date.getFullYear()
  return yyyy + '-' + mm + '-' + dd
}

export const formatDateString = (timeString: string): string =>
  formatDate(new Date(timeString))

export const areDatesEqual = (date: Date, dates: string[]): boolean => {
  const format = (d: Date) =>
    d.getFullYear() +
    '/' +
    (d.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    d.getDate().toString().padStart(2, '0')

  const dateString = format(date)

  return dates.every((dateStr) => format(new Date(dateStr)) === dateString)
}

export const getCharToTimeLength = (
  charLength: number,
  charTimeInMs: number
): number => {
  return (charTimeInMs * charLength) / 1000
}

export const formatTimeToMinutes = (time: number) => {
  // Convert to seconds
  const totalSeconds = Math.round(time)

  // Get minutes and seconds
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  // Pad the minutes and seconds with leading zeros if needed
  const minutesStr = minutes.toString().padStart(2, '0')
  const secondsStr = seconds.toString().padStart(2, '0')

  return `${minutesStr}:${secondsStr}`
}

export const formatDjangoTimeString = (timeString: string): number => {
  const timeParts = timeString.split(':')
  if (timeParts) {
    const hours = parseInt(timeParts[0])
    const minutes = parseInt(timeParts[1])
    const seconds = parseFloat(timeParts[2])
    return hours * 3600 + minutes * 60 + seconds
  } else {
    return 0
  }
}

export const formatSeconds = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.round(seconds % 60)
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}

export const formatDateNicely = (date: Date) => {
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getDate().toString().padStart(2, '0')}.${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
}

export const formatDateNicelyCzech = (date: Date) => {
  return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
}

export const isToday = (date: Date): boolean => {
  const today = new Date()
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}

export const hasDatePassed = (dateString: string): boolean => {
  const date = new Date(dateString)
  date.setHours(0, 0, 0, 0) // sets the time part to 0

  const now = new Date()
  now.setHours(0, 0, 0, 0) // sets the time part to 0

  return now > date
}

export const getHourNow = (): number => new Date().getHours()

export const getTomorrow = (): Date => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}

export const debounce = <F extends (...args: any[]) => any>(
  func: F,
  waitFor = 500
) => {
  let timeoutId: NodeJS.Timeout | null = null

  return (...args: Parameters<F>): ReturnType<F> | void => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(() => func(...args), waitFor)
  }
}

// @ts-ignore
export const sortByDatetimeKey = (a, b, key) => {
  return new Date(b[key]).getTime() - new Date(a[key]).getTime()
}
